import { apiWrapper } from "@/services/api";
import dbsService from "@/services/dbs";
import store from "@/store";

export const getDbsReportsForUsing = async () => {
  try {
    let url = dbsService.getUrlForReports();
    url += "&limit=1";

    const resp = await apiWrapper("GET", url, {}, false, null, "Migrated");

    // 予約情報に関するAPIレスポンスが他に散見するため、既存データにプッシュする形をとる
    const storeReservationData = store.getters["dbs/reservation"];
    if (storeReservationData == null) {
      store.commit("dbs/setReservation", resp.data[0]);
    } else {
      store.commit("dbs/setReservation", {
        ...storeReservationData,
        ...resp.data[0],
      });
    }
  } catch (err) {
    console.log('ERROR"" getDbsReportsForUsing()');
    throw err;
  }
};
